import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export function isMobile() {
  return window.innerWidth <= 991;
}


export function QuickTo(element, propriety, duration = .4, ease = "power3", overwrite = false) {
  if(!element) return;

  return gsap.quickTo(element, propriety, {duration: duration, ease: ease, overwrite: overwrite});
}

export function SetInitRandomPositions(setterElements) {
  if(!setterElements.length) return;

  gsap.set(setterElements, {
    x: () => gsap.utils.random(-300,  300),
    y: () => gsap.utils.random(300,  100),
    rotation: () => gsap.utils.random(-50,  50),
    opacity: 0,
  });
}

export function SetInitSimplePositions(setterElements) {
  if(!setterElements.length) return;

  gsap.set(setterElements, {
    y: 100,
    autoAlpha: 0,
  });
}

export function SimpleInView(batch) {
  if(!batch.length) return;

  ScrollTrigger.batch(batch, {
    interval: 0.1,
    start: () => "top 90%",
    clearProps: "all",

    onEnter: batch => gsap.to(batch, {
      autoAlpha: 1,
      y: 0,
      x:0,
      scale: 1,
      rotate: 0,
      stagger: 0.3,
      onComplete: () => {
        gsap.set(batch, {clearProps: "all"})
      }
    }),
  });

}

export function InViewTrigger(batchTrigger, setElementsBatch, onComplete = null) {
  return ScrollTrigger.batch(batchTrigger, {
    start: () => "top 90%",
    toggleActions: "play complete none none",
    invalidateOnRefresh: true,

    onEnter: batch => {
      const elements = typeof setElementsBatch === "function" ? setElementsBatch(batch) : batch;

      gsap.to(elements, {
        opacity: 1,
        x: 0,
        y: 0,
        rotation: 0,
        ease: "power3",
        stagger: .05,
        duration: .8,
        onComplete: () => {
          onComplete && onComplete(elements);}
      });
    },
  });
}

export function OnScrollAnimation(trigger, item, startPos, y, x, rotation, scale, customOptions = {}) {
  return ScrollTrigger.create({
    trigger,
    start: () => `top ${startPos}px`,
    scrub: true,
    invalidateOnRefresh: true,

    // markers: true,
    onUpdate: self => {
      const progress = self.progress.toFixed(3);

      gsap.to(item, {
        y: y && progress * y,
        x: x && progress * x,
        rotation: rotation ? progress * rotation : 0,
        scale: scale ? 1 - scale.toFixed(1) * progress : 1
      });
    },
    ...customOptions,
  });
}

export function FloatingAnimation(e, elements) {
  if(IsTouchDevice()) return;

  const centerX = e.clientX - (window.innerWidth / 2);
  const centerY = e.clientY - (window.innerHeight / 2);

  gsap.utils.toArray(elements).forEach(item => {
    if(!item.hasAttribute('data-mousemove-target')) return
    const targetSelector = item.getAttribute('data-mousemove-target');

    const target = item.querySelector(targetSelector);
    const xTo = QuickTo(target, "x");
    const yTo = QuickTo(target, "y");
    const rotateY = QuickTo(target, 'rotationY');
    const rotateX = QuickTo(target, 'rotationX');
    const rotate = QuickTo(target, 'rotation');

    rotate(centerX * item.randomRotate * .002);
    rotateX(centerX / window.innerWidth * 40);
    rotateY(centerY / window.innerWidth * 40);
    xTo(centerX * item.randomMouseX);
    yTo(centerY * item.randomMouseY);
  })
}

export function IsTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

export function WrapWordsInSpans(element) {
  if(!element) return;

  element.innerHTML = element.innerHTML.replace(/(?<!(<\/?[^>]*|&[^;]*))([^\s<]+)/g, '$1<span class="word">$2</span>')
}
